/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BasePageTitle.vue?vue&type=template&id=1b8e576a&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8e576a')) {
      api.createRecord('1b8e576a', component.options)
    } else {
      api.rerender('1b8e576a', component.options)
    }
    module.hot.accept("./BasePageTitle.vue?vue&type=template&id=1b8e576a&functional=true", function () {
      api.rerender('1b8e576a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BasePageTitle.vue"
export default component.exports